// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderViewOutlinedSvg from "@fishx/icons-svg/es/asn/FolderViewOutlined";
import FishxIcon from '../components/FishxIcon';

var FolderViewOutlined = function FolderViewOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderViewOutlinedSvg
  }));
};

FolderViewOutlined.displayName = 'FolderViewOutlined';
export default React.forwardRef(FolderViewOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderViewOutlined.js
// module id = 2816
// module chunks = 0